module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "prime_live_mobile.28e33bcb.webp";